import {AfterContentInit, Directive, ElementRef, Renderer2} from '@angular/core';
import {Content} from 'ionic-angular';

@Directive({
  selector: '[advtechHideFab]',
})
export class HideFabDirective implements AfterContentInit {
  private fabRef;
  private storedScroll: number = 0;
  private threshold: number = 10;

  constructor(public element: ElementRef, public renderer: Renderer2) {
  }

  ngAfterContentInit() {
    const ngComponent = this.element.nativeElement.closest('ng-component');
    this.fabRef = ngComponent.querySelector('.fabButton');
    ngComponent.querySelector('ion-nav .scroll-content').addEventListener('scroll', (event) => this.hScroll(event.target));
    this.renderer.setStyle(this.fabRef, 'webkitTransition', 'transform 500ms,bottom 500ms');
  }

  hScroll(event: Content) {
    if (event.scrollTop - this.storedScroll > this.threshold) {
      this.renderer.setStyle(this.fabRef, 'bottom', '-60px');
      this.renderer.setStyle(this.fabRef, 'webkitTransform', 'scale3d(.1,.1,.1)');
    } else if (event.scrollTop - this.storedScroll < 0) {
      this.renderer.setStyle(this.fabRef, 'bottom', '10px');
      this.renderer.setStyle(this.fabRef, 'webkitTransform', 'scale3d(1,1,1)');
    }
    this.storedScroll = event.scrollTop;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/directives/hide-fab/hide-fab.directive.ts